import React from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { setEmail } from "./userSlice";
import { setSession } from "./utils/session";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGoogleLogin = (response) => {
    const credentialResponse = JSON.parse(
      atob(response.credential.split(".")[1])
    );

    const userEmail = credentialResponse.email;

    // ✅ Save email in session
    setSession({ email: userEmail });

    // ✅ Save in Redux
    dispatch(setEmail(userEmail));

    navigate("/Project-Summary");
  };

  return (
    <div className="relative w-full h-screen flex items-center justify-center bg-pink-100">
      <div className="bg-pink-200 p-8 rounded-2xl shadow-lg w-96 text-center">
        <h1 className="text-xl font-bold text-gray-800">हक़दर्शक</h1>
        <h2 className="text-lg font-semibold text-gray-700 mt-2">Haqdarshak</h2>
        <p className="text-gray-600 mt-2">
          Welcome to Haqdarshak Analytics
        </p>

        <div className="mt-6">
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => alert("Google Sign-in failed")}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;